import { render, staticRenderFns } from "./ContactMemberList.vue?vue&type=template&id=0ca21f19"
import script from "./ContactMemberList.ts?vue&type=script&lang=ts&external"
export * from "./ContactMemberList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports